import { createApi } from "@reduxjs/toolkit/dist/query/react";

import { httpService } from "@services/http.service";

import { charactersApi } from "../characters";
import { courseApi } from "../course";
import { coursesApi } from "../courses";
import { exerciseEntrypointApi } from "../exercise-entrypoint";

import {
  IGetUserInfoApiResponse,
  IUpdateUserInfoApiParams,
  IUpdateUserInfoApiResponse,
} from "./user-info.types";

export const userInfoApi = createApi({
  reducerPath: "userInfoApi",
  baseQuery: httpService({
    baseUrl: `/api/v1/user/info/data`,
  }),
  tagTypes: ["userInfoData"],
  endpoints: (build) => ({
    getUserInfo: build.query<IGetUserInfoApiResponse, void>({
      query: () => ({ url: `/`, method: "get" }),
      providesTags: () => ["userInfoData"],
    }),
    updateUserInfo: build.mutation<
      IUpdateUserInfoApiResponse,
      IUpdateUserInfoApiParams
    >({
      query: ({ params }) => ({
        url: `/`,
        method: "put",
        data: params,
      }),
      invalidatesTags: () => ["userInfoData"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        await queryFulfilled;
        dispatch(
          exerciseEntrypointApi.util.invalidateTags(["exerciseEntrypointData"]),
        );
        dispatch(courseApi.util?.invalidateTags(["courseData"]));
        dispatch(coursesApi.util?.invalidateTags(["coursesData"]));
        dispatch(charactersApi.util?.invalidateTags(["charactersData"]));
      },
    }),
  }),
});

export const {
  // useGetUserInfoQuery,
  // useLazyGetUserInfoQuery,
  useUpdateUserInfoMutation,
} = userInfoApi;
